import { HStack, VStack } from '@chakra-ui/react';
import { Image } from '@common/components/Image';
import React from 'react';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';

type HeaderProps = {
  title?: string;
  breadCrumb?: React.ReactNode;
};

export const Header: React.FC<HeaderProps> = ({ breadCrumb, title }) => {
  return (
    <VStack alignItems={['flex-start']} gap="20px" width="full">
      {breadCrumb && breadCrumb}
      {title && (
        <HStack
          gap="20px"
          width="full"
          borderBottomColor="blackAlpha.100"
          borderBottomStyle="solid"
          borderBottomWidth="1px"
          paddingBottom={['12px', '12px', '12px', '36px']}>
          <Image image="cash-flow-icon" width={['24px', '24px', '24px', '48px']} />
          <TextBlock
            fontSize={['24px', '24px', '24px', '48px']}
            lineHeight={['32px', '32px', '32px', '48px']}
            weight="bold">
            {title}
          </TextBlock>
        </HStack>
      )}
    </VStack>
  );
};
